import { invert, makeEnum } from '@transcend-io/type-utils';

/**
 * Different categories allowed on preference store record.
 */
export const PreferenceStoreCategoryType = makeEnum({
  Purpose: 'PURPOSE',
  Identifier: 'IDENTIFIER',
});

/**
 * Override type
 */
export type PreferenceStoreCategoryType =
  (typeof PreferenceStoreCategoryType)[keyof typeof PreferenceStoreCategoryType];

/**
 * Inverted version of PreferenceStoreCategoryType
 */
export const InvertedPreferenceStoreCategoryType = invert(
  PreferenceStoreCategoryType,
);

/**
 * Override type
 */
export type InvertedPreferenceStoreCategoryType =
  (typeof InvertedPreferenceStoreCategoryType)[keyof typeof InvertedPreferenceStoreCategoryType];
